import { BaseComponent2 } from '../../_common/client/base-component2';
import { getCurrentMajorBreakpoint, MajorBreakpoint } from '../../_common/client/breakpoint';
import { push as showSnackbar } from '@otto-ec/otto-components/snackbar/v1';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export class CustomerReviewSummaryComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_cr-summary';

    public async init(): Promise<void> {
        this.initializeExpander();
        this.initializeFeedback();
        this.performViewTracking();
    }

    private initializeExpander(): void {
        const expander = this.getChildElement<HTMLOcExpanderV1Element>('.js_pdp_cr-summary__expander');
        if (!expander) {
            return;
        }

        if (this.isDesktop()) {
            expander.cutoffHeight = 5000;
        }

        expander.addEventListener('oc-expander-close', () => {
            trackEvent({ product_ReviewSummary: ['Fold'] });
        });

        expander.addEventListener('oc-expander-open', () => {
            trackEvent({ product_ReviewSummary: ['Unfold'] });
        });
    }

    private initializeFeedback(): void {
        this.getChildElements<HTMLOcButtonV1Element>('.js_pdp_cr-summary__feedback-button').forEach(buttonElement => {
            buttonElement.addEventListener('click', () => {
                const trackingValue = buttonElement.dataset.trackingValue;
                if (trackingValue) {
                    trackEvent({ product_ReviewSummary: [trackingValue] });
                }
                this.hideFeedback();
                showSnackbar('Vielen Dank für Dein Feedback!');
            });
        });
    }

    private hideFeedback(): void {
        this.getChildElement('.js_pdp_cr-summary__feedback')?.classList.add('pdp_cr-summary__feedback--hidden');
    }

    private performViewTracking() {
        trackView({
            product_ReviewSummary: ['True'],
        });
    }

    protected isDesktop(): boolean {
        return getCurrentMajorBreakpoint() === MajorBreakpoint.Desktop;
    }
}
